"use strict";

var _interopRequireWildcard = require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime/helpers/interopRequireWildcard.js");
var _interopRequireDefault = require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.map");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
var _toConsumableArray2 = _interopRequireDefault(require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
require("core-js/modules/es6.array.find-index");
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _vuex = require("vuex");
var _Tinymce = _interopRequireDefault(require("@/components/Tinymce"));
var banner = _interopRequireWildcard(require("@/api/banner"));
var store = _interopRequireWildcard(require("@/api/store"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    Tinymce: _Tinymce.default
  },
  computed: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(["token"])), (0, _vuex.mapState)({
    areas: function areas(state) {
      return state.area.list;
    }
  })),
  data: function data() {
    return {
      rules: {
        title: {
          required: true,
          trigger: "submit",
          message: "Vui lòng nhập tiêu đề"
        },
        phone: {
          required: true,
          trigger: "submit",
          message: "Vui lòng nhập số điện thoại"
        },
        banner: {
          required: true,
          trigger: "submit",
          message: "Vui lòng upload banner"
        },
        body: {
          required: true,
          trigger: "submit",
          message: "Vui lòng nhập mô tả"
        },
        areaId: {
          required: true,
          trigger: "submit",
          message: "Vui lòng chọn khu vực"
        },
        thumbnail: {
          required: true,
          trigger: "change",
          message: "Vui lòng tải banner lên"
        }
      },
      submitLoading: false,
      baseUrl: process.env.VUE_APP_BASE_API,
      baseUrlMedia: process.env.VUE_APP_BASE_URL_MEDIA,
      dialogLoading: false,
      formData: {
        type: "",
        openTime: "",
        closeTime: "",
        lat: 0,
        long: 0
      },
      dialogStatus: "",
      dialogVisible: false,
      loadingButton: false,
      stores: []
    };
  },
  created: function created() {
    this.fetchStore();
  },
  methods: {
    fetchStore: function () {
      var _fetchStore = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var search,
          areaId,
          res,
          _args = arguments;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              search = _args.length > 0 && _args[0] !== undefined ? _args[0] : "";
              areaId = this.formData.areaId ? this.formData.areaId : this.$store.state.user.info.area ? this.$store.state.user.info.area.id : undefined;
              if (areaId) {
                _context.next = 4;
                break;
              }
              return _context.abrupt("return", this.stores = []);
            case 4:
              _context.next = 6;
              return store.findAll({
                limit: 50,
                page: 1,
                search: search,
                areaId: areaId
              });
            case 6:
              res = _context.sent;
              this.stores = res.data.data;
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function fetchStore() {
        return _fetchStore.apply(this, arguments);
      }
      return fetchStore;
    }(),
    onChangeArea: function onChangeArea() {
      this.formData = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.formData), {}, {
        storeId: undefined
      });
      this.fetchStore();
    },
    createData: function createData() {
      var _this = this;
      this.$refs["form"].validate(function (valid) {
        if (valid) {
          _this.submitLoading = true;
          var data = {
            banner: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, _this.formData), {}, {
              selectType: _this.formData.SelectTypeList ? "LIST" : "SINGLE"
            }),
            areaId: _this.formData.areaId,
            storeId: _this.formData.storeId
          };
          banner.create(data).then(function () {
            _this.$message({
              type: "success",
              message: "Thêm banner thành công"
            });
            _this.$emit("create:success");
            _this.dialogVisible = false;
          }).finally(function () {
            _this.submitLoading = false;
          });
        }
      });
    },
    updateData: function updateData() {
      var _this2 = this;
      this.$refs["form"].validate(function (valid) {
        if (valid) {
          _this2.submitLoading = true;
          var data = {
            banner: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, _this2.formData), {}, {
              selectType: _this2.formData.SelectTypeList ? "LIST" : "SINGLE"
            }),
            areaId: _this2.formData.areaId,
            storeId: _this2.formData.storeId || 0
          };
          banner.update(_this2.formData.id, data).then(function () {
            _this2.$message({
              type: "success",
              message: "Cập nhật banner thành công"
            });
            _this2.$emit("update:success");
            _this2.dialogVisible = false;
          }).finally(function () {
            _this2.submitLoading = false;
          });
        }
      });
    },
    handleUpdate: function handleUpdate(row) {
      var _this3 = this;
      this.dialogVisible = true;
      console.log("formdata", this.formData);
      this.dialogStatus = "update";
      this.$nextTick(function () {
        _this3.$refs["form"].clearValidate();
        _this3.formData = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, row), {}, {
          areaId: row.area && row.area.id
        });
        if (row.store) {
          _this3.$set(_this3.formData, "storeId", row.store && row.store.id);
        }
        _this3.$refs["editor"].setContent(_this3.formData.body);
        console.log("row.shopType", row.shopType);
        _this3.$set(_this3.formData, "SelectTypeList", row.selectType == "LIST");
      });
      setTimeout( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var findIndex;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this3.fetchStore();
            case 2:
              if (row.store) {
                findIndex = _this3.stores.findIndex(function (item) {
                  return item.id == row.store.id;
                });
                if (findIndex == -1) {
                  _this3.stores = [].concat((0, _toConsumableArray2.default)(_this3.stores), [row.store]);
                }
              }
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      })));
    },
    handleCreate: function handleCreate() {
      var _this4 = this;
      this.dialogVisible = true;
      this.dialogStatus = "create";
      this.$nextTick(function () {
        _this4.$refs["form"].clearValidate();
        _this4.formData = {};
        if (_this4.$store.state.user.info.area) {
          _this4.$set(_this4.formData, "areaId", _this4.$store.state.user.info.area.id);
        }
        _this4.$set(_this4.formData, "selectType", false);
        _this4.$refs["editor"].setContent("");
      });
      setTimeout(function () {
        _this4.fetchStore();
      });
    },
    beforeUpload: function beforeUpload(file) {
      this.dialogLoading = true;
      var isJPG = file.type.includes("image");
      var isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.dialogLoading = false;
        this.$message.error("Avatar picture size can not exceed 2MB!");
      }
      if (!isJPG) {
        this.dialogLoading = false;
        this.$message.error("Ảnh không đúng định dạng!");
      }
      return isJPG && isLt2M;
    },
    handleUploadSuccess: function handleUploadSuccess(res, file) {
      this.$set(this.formData, "thumbnail", res.data.path);
      this.dialogLoading = false;
    },
    fetchDetailStore: function () {
      var _fetchDetailStore = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3(id) {
        var res, temp, key;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return store.findOne(id);
            case 2:
              res = _context3.sent;
              temp = [].concat((0, _toConsumableArray2.default)(this.stores), [res.data]);
              key = "id";
              this.stores = (0, _toConsumableArray2.default)(new Map(temp.map(function (item) {
                return [item[key], item];
              })).values());
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function fetchDetailStore(_x) {
        return _fetchDetailStore.apply(this, arguments);
      }
      return fetchDetailStore;
    }()
  }
};